import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgToiletMaleinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 64 64",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		strokeLinecap: "square",
		strokeLinejoin: "round",
		stroke: "currentColor",
		strokeWidth: 2,
		children: [/* @__PURE__ */ _jsx("circle", {
			cx: 32,
			cy: 10,
			r: 5
		}), /* @__PURE__ */ _jsx("path", { d: "M26.81 19h10.38a2 2 0 0 1 1.99 1.801L41 39H23l1.82-18.199A2 2 0 0 1 26.81 19zM29 59h6a2 2 0 0 0 2-2V39H27v18a2 2 0 0 0 2 2z" })]
	})
});
export default SvgToiletMaleinline;
